module.exports = __webpack_public_path__ + "img/onlineresume.c350f3ea.svg";